// extracted by mini-css-extract-plugin
module.exports = {"card":"highlight_card__1N0f9","link":"highlight_link__3KfY5","button":"highlight_button__3MT-y","text":"highlight_text__1r4Uz"};